import React, { useEffect, useState } from 'react';
import propTypes from 'prop-types';
import {
  Button,
  Card,
  CardContent,
  Columns,
  Column,
  MuiTitle,
} from 'src/ui/mui-ui-kit';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';

import {
  setBreadcrumbs,
  UiFieldset,
  InnerLoader,
  UiToastAdapter,
  UiSelectAdapter,
} from 'src/ui';
import { getUser, impersonateAccount } from 'src/user';
import { resetPassword } from 'src/auth';
import { Form, Field } from 'react-final-form';
import { composeValidators, required, number } from 'src/ui/validations';
import { cleanseInput, cleanseInt } from 'src/ui/util';
import arrayMutators from 'final-form-arrays';
import { updateFIPerson } from 'src/financial-institution';
import {
  UiToggleAdapter,
  UiInputAdapter,
  submitAndReset,
  UiSpacer,
} from '../../ui';
import { fetchLoggedInUser } from '../../user';
import { COMPLIANCE_ALERT_FREQUENCY } from '../const';
/*eslint-disable */
function MyAccountPage({
  user,
  setBreadcrumbs,
  impersonateAccount,
  updateFIPerson,
  fetchLoggedInUser,
}) {
  const [loading, setLoading] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  async function onResetPassword() {
    setLoading(true);

    const result = await resetPassword(user.email);

    if (!result.ok) {
      toast(UiToastAdapter(result.error.body, 'danger'));
    } else {
      toast(
        UiToastAdapter(
          'Password reset successfully, check your e-mail.',
          'success'
        )
      );
    }

    setLoading(false);
  }

  useEffect(() => {
    setBreadcrumbs([{ label: 'My Account', href: '/my-account' }]);
  }, []);

  useEffect(() => {
    if (user.isBankAdmin) {
      impersonateAccount({});
    }
    setIsAdmin(user.isBankAdmin);
  }, []);
  async function onDocumentNotificationSubmit(values) {
    setLoading(true);
    const result = await updateFIPerson({
      expirationNotificationFrequency: values.expirationNotificationFrequency,
      receiveExpirationNotification: values.receiveExpirationNotification,
      notifyOnDocumentUpload: values.notifyOnDocumentUpload,
      personId: user.id,
      financialInstitutionId: user.financialInstitutionId,
      firstName: user.firstName,
      lastName: user.lastName,
      emailAddress: user.email,
      roleId: user.roleId,
      primaryNumber: user.primaryNumber,
      complianceAlertIsActive: values.complianceAlertIsActive,
      complianceAlertNotifyFailed: values.complianceAlertNotifyFailed,
      complianceAlertNotifyPassed: values.complianceAlertNotifyPassed,
      complianceAlertNotifyReview: values.complianceAlertNotifyReview,
      complianceAlertFrequency: values.complianceAlertFrequency.label,
    });
    await fetchLoggedInUser();
    if (result.isError) {
      toast(UiToastAdapter('An Error Occured', 'danger'));
    } else {
      toast(UiToastAdapter('Notifications Updated Successfully', 'success'));
    }

    setLoading(false);
  }
  return (
    <>
      <InnerLoader visible={loading} />
      <MuiTitle isSize="4" hasTextColor="info" tag="h2">
        My Account
      </MuiTitle>
      <Card>
        <CardContent>
          <UiFieldset title="Password reset">
            <CardContent>
              <p className="has-text-grey-medium-dark">
                Press the button below to reset your password and receive an
                e-mail message with a link to create a new one.
              </p>
              <Button
                isColor="gradient-bright"
                className="is-long"
                onClick={onResetPassword}
              >
                <span className="icon">
                  <FontAwesomeIcon icon={['fal', 'key']} />
                </span>
                <span>Reset password</span>
              </Button>
            </CardContent>
          </UiFieldset>
        </CardContent>
      </Card>
      <UiSpacer />
      {isAdmin && (
        <NotificationsForm
          data={{
            receiveExpirationNotification: user.receiveExpirationNotification,
            expirationNotificationFrequency: user.expirationNotificationFrequency.toString(),
            notifyOnDocumentUpload: user.notifyOnDocumentUpload,
            complianceAlertIsActive: user.complianceAlertEmail.isActive,
            complianceAlertNotifyFailed: user.complianceAlertEmail.notifyFailed,
            complianceAlertNotifyPassed: user.complianceAlertEmail.notifyPassed,
            complianceAlertNotifyReview: user.complianceAlertEmail.notifyReview,
            complianceAlertFrequency: COMPLIANCE_ALERT_FREQUENCY.find(
              el => el.label === user.complianceAlertEmail.frequency
            ),
          }}
          onSubmit={onDocumentNotificationSubmit}
        />
      )}
    </>
  );
}

const NotificationsForm = ({ onSubmit, data }) => {
  const [receiveExpNotification, setReceiveExpNotification] = useState(
    data.receiveExpirationNotification
  );

  return (
    <Card>
      <CardContent>
        <Form
          onSubmit={onSubmit}
          initialValues={data}
          mutators={{
            cleanse: ([event, cleansing], state, { changeValue }) => {
              cleanseInput(event, state, changeValue, cleansing);
            },
            ...arrayMutators,
          }}
          render={({
            form,
            hasValidationErrors,
            submitting,
            handleSubmit,
            dirty,
          }) => {
            const submit = submitAndReset(handleSubmit, form);
            return (
              <form onSubmit={submit} noValidate>
                <UiFieldset title="Document Notifications">
                  <UiSpacer />
                </UiFieldset>
                <Columns>
                  <Column isSize="1/2">
                    <Field
                      component={UiToggleAdapter}
                      id="receiveExpirationNotification"
                      name="receiveExpirationNotification"
                      type="checkbox"
                      onClick={e =>
                        setReceiveExpNotification(!receiveExpNotification)
                      }
                    >
                      Receive Document Expiration Notifications
                    </Field>
                    <Field
                      component={UiToggleAdapter}
                      id="notifyOnDocumentUpload"
                      name="notifyOnDocumentUpload"
                      type="checkbox"
                    >
                      Receive Document Upload Notifications
                    </Field>
                  </Column>
                  <Column isSize="1/2">
                    <Field
                      component={UiInputAdapter}
                      id="expirationNotificationFrequency"
                      name="expirationNotificationFrequency"
                      label="Notify Days Before Expiration"
                      required={receiveExpNotification}
                      validate={
                        receiveExpNotification &&
                        composeValidators(
                          'Notify Days Before Expiration',
                          required,
                          number({ min: 0, max: 120 })
                        )
                      }
                      onChange={e => form.mutators.cleanse(e, cleanseInt)}
                      disabled={!receiveExpNotification}
                    />
                  </Column>
                </Columns>
                <UiSpacer />
                <UiFieldset title="Compliance Notifications">
                  <UiSpacer />
                </UiFieldset>
                <Columns isMultiline>
                  <Column isSize="1/2">
                    <Field
                      component={UiToggleAdapter}
                      id="complianceAlertIsActive"
                      name="complianceAlertIsActive"
                      type="checkbox"
                    >
                      Subscribe To Compliance Notification Emails
                    </Field>
                  </Column>
                  <Column isSize="1/2">
                    <Field
                      component={UiSelectAdapter}
                      id="complianceAlertFrequency"
                      type="dropdown"
                      name="complianceAlertFrequency"
                      label="Frequency"
                      options={COMPLIANCE_ALERT_FREQUENCY}
                      getOptionLabel={item => item.label}
                      getOptionValue={item => item.value}
                      // onFocus={() => setHandleChange(true)}
                    />
                  </Column>
                  <Column isSize="1/3">
                    <Field
                      component={UiToggleAdapter}
                      id="complianceAlertNotifyPassed"
                      name="complianceAlertNotifyPassed"
                      type="checkbox"
                    >
                      Alert When Passed
                    </Field>
                  </Column>
                  <Column isSize="1/3">
                    <Field
                      component={UiToggleAdapter}
                      id="complianceAlertNotifyFailed"
                      name="complianceAlertNotifyFailed"
                      type="checkbox"
                    >
                      Alert When Failed
                    </Field>
                  </Column>
                  <Column isSize="1/3">
                    <Field
                      component={UiToggleAdapter}
                      id="complianceAlertNotifyReview"
                      name="complianceAlertNotifyReview"
                      type="checkbox"
                    >
                      Alert When Needs Review
                    </Field>
                  </Column>
                </Columns>
                <UiSpacer />
                <Button
                  isColor="gradient-bright"
                  type="submit"
                  disabled={submitting || hasValidationErrors || !dirty}
                >
                  Submit
                </Button>
              </form>
            );
          }}
        />
      </CardContent>
    </Card>
  );
};

MyAccountPage.propTypes = {
  user: propTypes.object.isRequired,
  setBreadcrumbs: propTypes.func.isRequired,
  impersonateAccount: propTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    user: getUser(state),
  };
}

const connectedMyAccountPage = connect(mapStateToProps, {
  setBreadcrumbs,
  impersonateAccount,
  updateFIPerson,
  fetchLoggedInUser,
})(MyAccountPage);

export { connectedMyAccountPage as MyAccountPage };
